import { instantBaseApi } from "@/services/instantApi";
import { ThemeStyle, ThemeStyleUpdateDocument, shopifyDefaultThemeDocument } from "./gql";

export const getShopifyDefaultTheme = async () => {
  return await instantBaseApi(
    JSON.stringify({
      query: shopifyDefaultThemeDocument,
    })
  );
}

export const getThemeStyle = async (themeID) => {
  return await instantBaseApi(
    JSON.stringify({
      query: ThemeStyle,
      variables: {
        first: 1,
        where: {
          default: true,
          themeID
        }
      }
    })
  );
}

export const updateThemeStyle = async (id, data) => {
  return await instantBaseApi(
    JSON.stringify({
      query: ThemeStyleUpdateDocument,
      variables: {
        id,
        input: {
          data
        }
      }
    })
  );
}
